module.exports = __webpack_public_path__ + "img/red-desert-decal-05.cdead6b0.png";